window.dataLayer = new Proxy(window.dataLayer || [], {
    set: function(target, property, value) {
        try {
            if (value.event === 'experience_impression') {
                Shopify.analytics.publish('dw:dataLayerPush', { ...value, eventCallback: undefined });
            }
        } catch (e) {}
        target[property] = value;
        return true;
    }
});
